var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-card"},[_c('div',{ref:"instrumentChart",staticClass:"plan-box"})])}
var staticRenderFns = []

export { render, staticRenderFns }